import angular from 'angular';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';
import datepickerTemplate from './templates/datepicker.html';
import dayTemplate from './templates/day.html';
import monthTemplate from './templates/month.html';
import yearTemplate from './templates/year.html';
import popupTemplate from './templates/popup.html';
import RwDatepickerComponent from './rw-datepicker-component';

angular
  .module('rw-datepicker/templates/datepicker.html', [])
  .run(["$templateCache", function ($templateCache) {
    $templateCache.put('rw-datepicker/templates/datepicker.html', datepickerTemplate);
  }]);

angular
  .module('rw-datepicker/templates/day.html', [])
  .run(["$templateCache", function ($templateCache) {
    $templateCache.put('rw-datepicker/templates/day.html', dayTemplate);
  }]);

angular
  .module('rw-datepicker/templates/month.html', [])
  .run(["$templateCache", function ($templateCache) {
    $templateCache.put('rw-datepicker/templates/month.html', monthTemplate);
  }]);

angular
  .module('rw-datepicker/templates/year.html', [])
  .run(["$templateCache", function ($templateCache) {
    $templateCache.put('rw-datepicker/templates/year.html', yearTemplate);
  }]);

angular
  .module('rw-datepicker/templates/popup.html', [])
  .run(["$templateCache", function ($templateCache) {
    $templateCache.put('rw-datepicker/templates/popup.html', popupTemplate);
  }]);

export default angular
  .module('rw-datepicker', [
    'rw-datepicker/templates/datepicker.html',
    'rw-datepicker/templates/day.html',
    'rw-datepicker/templates/month.html',
    'rw-datepicker/templates/year.html',
    'rw-datepicker/templates/popup.html',
    datepickerPopup,
  ])
  .component('rwDatepicker', new RwDatepickerComponent());




// WEBPACK FOOTER //
// ./src/modules/utils/rw-datepicker/rw-datepicker-module.js